/**
 * The next scheduled session, so a quiet frame still reads as a plan.
 *
 * Appears beneath a calm card on the frames with nothing to start, and beside
 * the pick card on the make-up frame — where it carries a border so it reads as
 * a sibling of the card above rather than part of it.
 */

import { CalendarDaysIcon } from '@heroicons/react/24/outline';

import { nextUpLabel } from '@personal-trainer-app/shared/src/utils/workout/start-options';

import type { NextUpBlockProps } from './StartWorkoutSheet.types';

import { Text } from '@/components/ui/primitives';

export function NextUpBlock({
  nextDue,
  onCard = false,
}: NextUpBlockProps): React.JSX.Element | null {
  if (!nextDue) return null;

  return (
    <div
      className={`mt-2.5 flex items-center gap-2.5 rounded-md px-3 py-2.5 ${
        onCard
          ? 'border border-stroke-subtle bg-contrast-700'
          : 'bg-contrast-600'
      }`}
      data-testid="start-workout-next-up"
    >
      <CalendarDaysIcon
        className="h-4 w-4 flex-none text-neutral-500"
        aria-hidden="true"
      />
      <div className="min-w-0">
        <Text
          as="div"
          variant="label-xs"
          color="muted"
          className="font-semibold uppercase tracking-wider"
        >
          {nextUpLabel(nextDue)}
        </Text>
        <Text
          as="div"
          variant="body-md"
          className="mt-px truncate font-semibold text-neutral-200"
        >
          {nextDue.workout.name}
        </Text>
      </div>
    </div>
  );
}

export default NextUpBlock;
